"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingWithdrawPenaltyDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_query_1 = require("@tanstack/react-query");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const exchange_1 = require("@framework/exchange");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const withdrawBalance_json_1 = __importDefault(require("@framework/abis/json/Staking/withdrawBalance.json"));
const provider_api_firebase_1 = require("@dzambalaorg/provider-api-firebase");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const StakingWithdrawPenaltyDialog = (props) => {
    const { data } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const api = (0, provider_api_firebase_1.useApi)();
    const { data: rows = [], isLoading } = (0, react_query_1.useQuery)({
        queryKey: [`/staking/penalty/${data.id}`],
        queryFn: async () => {
            return api
                .fetchJson({
                url: `/staking/penalty/${data.id}`,
            })
                .then((res) => {
                if (res?.penalty) {
                    return res.penalty.components;
                }
                else {
                    return [];
                }
            });
        },
    });
    const { execute: metaWithdrawPenalty } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        return writeContractAsync({
            address: data.address,
            abi: withdrawBalance_json_1.default,
            functionName: "withdrawBalance",
            args: [
                {
                    tokenType: Object.keys(types_1.TokenType).indexOf(values.tokenType),
                    token: values.contract?.address,
                    tokenId: values.tokenType === types_1.TokenType.ERC721 || values.tokenType === types_1.TokenType.ERC998
                        ? values.token.tokenId
                        : values.templateId, // must match with staking.penalties[item.token][item.tokenId];
                    amount: 0, // whatever
                },
            ],
        });
    });
    const handleWithdraw = (values) => {
        return async () => {
            return metaWithdrawPenalty(values);
        };
    };
    return ((0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: rows.length, isLoading: isLoading, children: rows.map(comp => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { sx: { width: 0.6 }, children: `${comp.template.title} ${comp.token ? ` #${comp.token.tokenId}` : ""}` }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: (0, exchange_1.formatEther)(comp.amount, comp.contract.decimals, comp.contract.symbol) }), (0, jsx_runtime_1.jsx)(styled_1.ListActions, { children: (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleWithdraw(comp), message: "form.buttons.withdraw", icon: icons_material_1.PriceChange }) })] }, comp.id))) }) }));
};
exports.StakingWithdrawPenaltyDialog = StakingWithdrawPenaltyDialog;
//# sourceMappingURL=index.js.map